<template>
	<div>
		<div class="title-container">
			<div class="title">Inquiry Details</div>
			<div class="buttons">
				<router-link v-if="$root.isSuperAdmin" :to="`/inquiries/${$route.params.id}/details/json`" class="button"><div class="hover-title">View JSON</div><span class="fab fa-js"></span></router-link>
				<router-link to="/inquiries" class="button"><div class="hover-title">Go Back</div><span class="fa fa-chevron-left"></span></router-link>
			</div>
		</div>

		<div v-for="key in Object.keys(data)" :key="`data-${key}`" class="input-container">
			<div class="input-title">{{ key | uppercase }}</div>
			<div v-if="key === 'message'"  class="input-box">
				<textarea-autosize v-model="message" readonly></textarea-autosize>
			</div>
			<div v-else  class="input-static-text">
				{{ data[key] }}
			</div>
		</div>
	</div>
</template>

<script>

import moment from 'moment-timezone';
import _ from 'underscore';

export default {

	name: 'InquiryDetailsPage',

	data() {
		return {
			loading: true,
			rawData: {},
			message: '',
			data: {},
		};
	},

	mounted() {
		this.loadInquiry(this.$route.params.id);
	},

	methods: {

		async loadInquiry(id) {
			this.loading = true;

			const { data } = await this.$api.get('/inquiries/' + id);

			this.rawData = data;
			this.setInquiry();
			this.loading = false;
		},

		setInquiry() {
			let data = this.rawData.data;

			data = _.omit(data, ['_token', 'subject']);

			data.date = moment.tz(this.rawData.created_at, 'UTC').tz(moment.tz.guess()).format('MMMM DD, YYYY @ hh:mm a');
			data.legitimate = this.rawData.successful ? 'Yes' : 'No';
			this.message = data.message;

			this.data = data;
		},

	},

};

</script>
